<template>
  <b-card class="global-card component-inside-1--hover full-bordered py-2 px-0 mb-3">
    <div>
      <b-row class="d-flex align-items-center">
        <b-col class="d-flex align-items-center pt-2">
          <div class="d-flex align-items-center ap-title ap-title__section">
            <i
              class="far fa-prescription-bottle"
              aria-hidden="true"
            />
            <span class="primary-dark-color mx-2">{{ macro.sampleLabel }}</span>
          </div>
          <!--TODO: Consultar pablo-->
          <!--<span class="mx-2">{{sample.loc}}</span>
                    <span>{{macro.type}}</span>-->
        </b-col>
        <b-col class="d-flex justify-content-end">
          <b-button
            v-tooltip="$t('diagnosis.labels.openSample')"
            class="btn__icon btn__icon--primary px-0 ml-2 mr-0"
            s
            @click="$emit('selectSampleFromMacro', macro.sampleId)"
          >
            <i
              class="far fa-external-link"
              aria-hidden="true"
            />
          </b-button>
        </b-col>
      </b-row>
      <b-row class="py-1">
        <b-col>
          <vt-rich-text-editor
            v-if="macro.text"
            input-id="descriptionDescriptionInput"
            class="mt-3 mb-1 descriptionText macro"
            :autofocus="true"
            :value="macro.text"
            :disabled="true"
          />
          <span v-if="!macro.text">-</span>
        </b-col>
      </b-row>
    </div>
  </b-card>
</template>

<script>
export default {
    name: 'MacroCard',
    props: {
        macro: { type: Object, required: true }
    }
}
</script>

<style lang="scss">

    .global-card .descriptionText .ql-toolbar {
        display: none;
    }

    .global-card .descriptionText .ql-container {
        word-break: break-word;
        border: none;
    }

    .global-card .descriptionText .ql-container .ql-editor {
        padding: 0;
        color: vt-color(dark-text);
    }

    .global-card .sample-title {
        color: vt-color(dark-text);
    }

    .global-card .quill-editor .ql-editor p {
        margin-bottom: 0;
    }

</style>
